import { ReactComponent as Close } from 'assets/solomonShip/close.svg'
import { useEffect } from 'react';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    url: string
}

const ImgModal = ({ isOpen, setIsOpen, url }: IConfrimDialog) => {

    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                if (isOpen) {
                    setIsOpen(false)
                }
            }
        }

        document.addEventListener('keydown', handleEsc)

        // cleanup
        return () => {
            document.removeEventListener('keydown', handleEsc)
        }
    }, [isOpen])

    if (!isOpen) return null;


    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50" onClick={() => setIsOpen(false)}>
                <Close fill='white' className='top-4 right-4 absolute mobile:w-6 mobile:h-6 cursor-pointer' onClick={() => setIsOpen(false)} />
                <img src={url} alt="img" />
            </div>
        </div>
    );
};

export default ImgModal;